import { Table, Popover } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { evaluationQuestions } from "views/Requisition/AddUpdateEmployeeEvaluation/Includes/evaluationQuestions";

const EvaluationTable = ({ participantEmployeeEvaluationForm, Supervisor }) => {
  const [selectedRecord, setSelectedRecord] = useState(null);

  useEffect(() => {
    if (Supervisor !== undefined) {
      setSelectedRecord(Supervisor);
    }
  }, [Supervisor]);

  //console.log("EvaluationTable ", selectedRecord);
  //console.log("EvaluationTable  ", participantEmployeeEvaluationForm);

  const columns = [
    {
      title: "Evaluation Criteria",
      dataIndex: "title",
      key: "title",
      render: (text, record) => (
        <>
          {record.title}{" "}
          <Popover content={record.description}>
            <ExclamationCircleOutlined />
          </Popover>
        </>
      ),
    },
    {
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
    },
  ];

  // Flatten each evaluation field into row data
  const dataSource = evaluationQuestions.map((criteria, index) => {
    const rating =
      participantEmployeeEvaluationForm?.[0]?.[criteria.key]?.number || "N/A";
    const comment =
      participantEmployeeEvaluationForm?.[0]?.[criteria.key]?.comments || "";
    return {
      key: index,
      title: criteria.title,
      description: criteria.description,
      rating,
      comment,
    };
  });

  return (
    <>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        bordered
      />

      <br />

      <div>
        <strong>Major Strength1:</strong>{" "}
        {participantEmployeeEvaluationForm?.[0]?.majorStrength || "N/A"}
      </div>
      <div>
        <strong>Areas of Improvement:</strong>{" "}
        {participantEmployeeEvaluationForm?.[0]?.areasOfImprovement || "N/A"}
      </div>
    </>
  );
};

export default EvaluationTable;
